import type { UnionTypeLibelle } from '@/features/domaine/types/techniques'

export const AnneeFormation = ['Premiere', 'Seconde', 'Troisieme', 'Quatrieme'] as const

export type AnneeFormation = (typeof AnneeFormation)[number]

export const AnneeFormationLibelle: UnionTypeLibelle<AnneeFormation> = {
  Premiere: 'Première année',
  Seconde: 'Seconde année',
  Troisieme: 'Troisième année',
  Quatrieme: 'Quatrième année',
} as const
